import React from "react";

export default class CourseCollectionNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articlesOpenCourseId: this.props.course ? this.props.course.id : null,
    };

    this.onOpenArticles = this.onOpenArticles.bind(this);
  }

  componentDidMount() {
    this.toggleActiveArticles(false);
  }

  componentDidUpdate() {
    this.toggleActiveArticles(true);
  }

  render() {
    var self = this;
    var courses = this.props.courses.map(function (course) {
      return self.renderCourse(course);
    });

    return (
      <div className="CourseCollectionNavigation">
        <div className="CourseCollection">
          <div
            className="Name"
            dangerouslySetInnerHTML={{ __html: this.props.name }}
          ></div>
        </div>
        <div ref="courses">{courses}</div>
      </div>
    );
  }

  renderArticle(article) {
    if (this.props.article.id === article.id) {
      // active article
      return (
        <a
          key={article.id}
          href={article.path}
          className="Article ActiveArticle"
          dangerouslySetInnerHTML={{
            __html: `${
              article.position -
              (this.props.suppress_intros_and_summaries ? 1 : 0)
            } &nbsp; ${article.name}`,
          }}
        ></a>
      );
    } else {
      // non-active article
      return (
        <a
          key={article.id}
          href={article.path}
          className="Article"
          dangerouslySetInnerHTML={{
            __html: `${
              article.position -
              (this.props.suppress_intros_and_summaries ? 1 : 0)
            } &nbsp; ${article.name}`,
          }}
        ></a>
      );
    }
  }

  renderCourse(course) {
    var self = this;
    var articles_length = course.articles.length;
    var articles = course.articles.map(function (article, idx) {
      if (
        self.props.suppress_intros_and_summaries &&
        (idx === 0 || idx + 1 === articles_length)
      ) {
        // suppress
      } else {
        return self.renderArticle(article);
      }
    });

    return (
      <div
        key={course.id}
        className="Course"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            this.onOpenArticles(course.id);
          }
        }}
        onClick={this.onOpenArticles.bind(this, course.id)}
      >
        <div
          className="Name"
          dangerouslySetInnerHTML={{ __html: course.name }}
        ></div>
        <div className="ArticleCount">
          {course.articles.length -
            (this.props.suppress_intros_and_summaries ? 2 : 0)}
        </div>
        <div
          className={
            "Articles " +
            (this.state.articlesOpenCourseId === course.id
              ? "ArticlesOpen"
              : "")
          }
        >
          {articles}
        </div>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onOpenArticles(course_id) {
    this.setState({ articlesOpenCourseId: course_id });
  }

  /**
   * Helper functions
   */

  toggleActiveArticles(animate) {
    var $courses = $(this.refs.courses);

    if (animate) {
      $courses.find(".Articles").not(".ArticlesOpen").slideUp("fast");
      $courses.find(".ArticlesOpen").slideDown("fast");
    } else {
      $courses.find(".ArticlesOpen").show();
      $courses.find(".Articles").not(".ArticlesOpen").hide();
    }
  }
}
